module.exports = __webpack_public_path__ + "static/1.e4553644.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/LowDamage/1.gif
// module id = 715
// module chunks = 56660325458610 135966999058180 206171068497285